/**
 * (perf, Sep 17 — docs/PERF.md) a grid of entities by cell, rebuilt once a step, so the drivers' scans and the run-over check
 * look at the cars and people round a car instead of at every one in the world. Measured before it: in a city core each of
 * 80 driven cars made four passes over 180 vehicles and one over 216 people every step — 140 k distance tests a step, 7 ms
 * of a 12.6 ms step. Nothing in the rules looks further than `near`'s radius asks for, so what a driver sees is the same.
 */
export class SpatialGrid<T extends { x: number; y: number }> {
  private cells = new Map<number, T[]>();
  constructor(readonly cell = 32) {}
  private static key(cx: number, cy: number): number { return (cx + 32768) * 65536 + (cy + 32768); }
  /** the cells from the items as they stand now (the arrays are kept and refilled: no garbage a step) */
  build(items: readonly T[]): void {
    for (const arr of this.cells.values()) arr.length = 0;
    for (const it of items) {
      const k = SpatialGrid.key(Math.floor(it.x / this.cell), Math.floor(it.y / this.cell));
      let arr = this.cells.get(k);
      if (!arr) { arr = []; this.cells.set(k, arr); }
      arr.push(it);
    }
  }
  /** every item in the cells the square of radius `r` round (x, y) touches — a superset of what is within `r`, in cell order; `out` is cleared and refilled */
  near(x: number, y: number, r: number, out: T[]): T[] {
    out.length = 0;
    const cx0 = Math.floor((x - r) / this.cell), cx1 = Math.floor((x + r) / this.cell), cy0 = Math.floor((y - r) / this.cell), cy1 = Math.floor((y + r) / this.cell);
    for (let cy = cy0; cy <= cy1; cy++) for (let cx = cx0; cx <= cx1; cx++) { const arr = this.cells.get(SpatialGrid.key(cx, cy)); if (arr) for (const it of arr) out.push(it); }
    return out;
  }
}
